<template>
  <div class="box">
    <div class="box1">
      <div class="boxleft">
        <!-- 图片 -->
        <img src="../assets/img/16device.png" style="height:276px;width:459.37px;margin-left:66px;margin-top:50px;margin-bottom:50px;"/>
      </div>
      <div class="boxright">
        <p>YOGA Tab Plus<br />Android 16 Developer <br />Preview Program</p>
        <p class="boxp">Great news！Our build is available.</p>
      </div>
    </div>
    <div class="box2">
      <div class="boxcontent">
        <h2 style="padding-top: 40px">What’s new</h2>
        <ul>
          <p class="box4p">
            Android 16 comes with enhancements to the app experience, improve battery life, and boost performance while minimizing<br/>
            incompatibilities to boost your productivity, give users a premium app experience, protect user privacy and security, and <br/>
            make your app accessible to as many people as possible while continuing to refine the large-screen device experience on <br/>
            tablets, foldables, and more..  Android 16 focuses on giving users more control over their health and safety, improving<br/>
            accessibility options, and letting them express themselves and their individuality through devices like never before.
          </p>
          <li>Security patch updated to Feb. 2025</li>
        </ul>
        <p>
          Plan ahead and proactively ready your apps for the official market release of Android 16 developer preview.
        </p>
      </div>
      <img src="../assets/img/16logo.svg" style="height:240px;width:240px;margin-bottom: 20px;"/>
    </div>
    <div class="box3">
      <div class="boxcontent" style="margin-left: 52px;">
        <h2 style="padding-top: 40px">Important Notes</h2>
        <p class="box4p">
          Please review the points below before proceeding with the registration process:
        </p>
        <div style="margin-right: 52px">
          <ul>
            <li>
              Android 16 developer preview builds are early Android OS releases and are intended for 
              application developers only – they are not recommended for general use.
            </li>
            <li>
              Although strenuously tested by our development team, the builds may display performance
               and/or stability issues in some instances.
            </li>
            <li>
              Some applications downloaded from the Google Play Store may not be supported
               (either in full or partially) and may behave erratically.
            </li>
            <li>
              Online support is limited and may not be available to help users who experience
               difficulties with flashing the device.
            </li>
            <li>
              The Beta image is not the final version, and some features might be missing or not working well.
            </li>
          </ul>
        </div>
        <p class="te">
          If you have any concerns on whether these builds are suitable for your use, we recommend you do not 
          continue with developer preview registration and wait for the official market release.
        </p>
        <p class="gray" style="margin-top: 20px;">
          <span>Note:</span>Please note, we may not be able to offer Android developer preview builds to devices on certain network providers.
        </p>
      </div>
    </div>
    <div class="box4">
      <div class="boxcontent" style="margin-left: 62px;">
        <h2 style="padding-top: 40px; margin-left: -10px;">Ready to get started?</h2>
        <div>
          <p class="box4p" style="width: 933px">
            Please double check YOGA Tab Plus device on your hand is WIFI version and ensure only flash Beta image to the device 
            purchased outside of China mainland. Wrong device SW flashing will cause device bricked. Several ways to identify WIFI device:
          </p>
          <ul style="margin-left: 5px">
            <li>Check the sales box</li>
            <li>
              Go to &lt;System&gt; in &lt;Settings&gt; on your device, the Model 
              name in &lt;About tablet&gt; is "Lenovo TB520FU"
            </li>
          </ul>
          <p class="box4p" style="margin-bottom: 40px;">
            Please remember that software flashing will result in the loss of
            user data, we recommend that you backup your personal data <br/> properly
            before a software flashing.
          </p>
          <ul class="box4ul" style="margin: 0;">
            <!-- <li>
              &nbsp;1. Download
              <a
                href="https://ota-cdn.lenovo.com/firmware/20235915399425-2445.zip"
                >SW flashing packages</a
              >
              and install & configure your PC environment by following the
              instruction <br/><b>inside the package.</b>
            </li> -->
            <p>
              Download and unzip
              <a href="https://ota-cdn.lenovo.com/firmware/2025429135724964-2484.zip" >Android 16 developer preview Beta3 image</a>
              on your local drive, and then flash your device following the corresponding instruction in SW flashing packages.
            </p>
          </ul>
        </div>
        <li style="list-style-type: none">
          Now your device should be ready. Please visit the
          <a
            href="https://developer.android.com/about/versions/16"
            target="_blank"
            >Android 16 developer preview site</a
          >
          for details on how to set up your environment in Android Studio.
        </li>
        <h3>SW limitation</h3>
        <div style="margin-right: 52px">
          <p style="margin-bottom: 0;">
            To serve a stable system SW to support your development as quick as possible, 
            some functions on <b>Lenovo Yoga Tab Plus</b> official SW are tailored,
            please check the details below.
          </p>
          <ul class="box4ul2">
            <li>Fingerprint unlock is not supported</li>
            <li>Face Unlock is not supported</li>
            <li>TOF sensor related function is removed</li>
            <li>Stylus key function is not supported but basic function works</li>
            <li>Miracast function is not supported</li>
            <li>Screen output via cable, only mirror screen is supported</li>
            <li>VPN is not tested and may not work properly</li>
            <li>WIDI is not supported</li>
            <li>One Vision is not supported</li>
            <li>Reading Mode is not supported</li>
            <li>Adapt color to environment is not supported</li>
            <li>Smart Accessories is not supported</li>
          </ul>
          <h3>Key notes</h3>
          <ul style="margin-left: 2px; padding-bottom: 40px">
            <li>
              Please manually connect keyboard to your device via Bluetooth
               to display battery info of keyboard in Settings.
            </li>
          </ul>
        </div>
      </div>
      <img src="../assets/img/icon3.svg" />
    </div>
    <div class="box5">
      <div class="boxcontent5">
        <h2 style="padding-top: 40px">Rollback to official release</h2>
        <p>
          We really hope you’ll continue with the Android 16 developer preview and share your feedback, 
          but if you’d prefer to return to the official release software, 
          you can do so by requesting a rollback through this tool.
          <br /><a
            href=" https://support.lenovo.com/us/en/downloads/ds101291"
            target="_blank"
            >https://support.lenovo.com/us/en/downloads/ds101291</a
          ><br />
          This tool currently only supports WIFI device which is on sale outside of China markets.
        </p>
        <p>Advisory notice:</p>
        <ul style="padding-bottom: 40px">
          <li>
            Please remember that rollback to an official market release will result in the 
            loss of user data. We recommend that you periodically backup any important data 
            such as contacts, call logs, pictures, videos, music, installed apps, 
            chat history, SMS history, notes, etc. You may also need to re-install 
            any applications previously downloaded.
          </li>
          <li>
            Ideally, your device should be fully charged, but a minimum of 60% charge is recommended.
          </li>
          <li>
            Please note you will not be able use the device – including any attempts to make an emergency 
            call – until the installation is complete and the device has booted into a stable state.
          </li>
          <li>The tool currently only supports Windows OS.</li>
        </ul>
      </div>
    </div>
    <p class="gray" style="padding-bottom: 15px">Update Apr. 2025</p>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>

.box {
  width: 1342px;
  /* width: 90% !important; */
  margin: 0 auto;
}
.box1 {
  height: 376px;
  background: #ffffff;
  border-radius: 28px;
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
}
.box1 img {
  width: 582px;
  height: 381px;
  margin-top: 45px;
  margin-left: 5px;
}
.boxright {
  width: 700px;
  margin-top: 86px;
  /* margin-left: 119.63px; */
}
.boxright p {
  font-size: 52px;
  color: #181818;
  margin: 0;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  line-height: 52px;
  margin-bottom: 30px;
}
.boxright .boxp {
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 16px;
  color: #181818;
}
.box .box2 {
  height: 399px;
  background: #ffffff;
  border-radius: 28px;
  margin-top: 32px;
  margin-bottom: 32px;
  position: relative;
}
.boxcontent {
  margin-left: 42px;
}
.boxcontent5 {
  margin-left: 52px;
  margin-right: 52px;
}
.h2 {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 28px;
  color: #000000;
  padding-top: 40px;
}
.box ul li {
  list-style-type: disc;
  margin-left: 20px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
}
.gray {
  color: #999;
  font-size: 16px;
  line-height: 24px;
  font-family: Lato;
  font-style: normal;
}
.box2 img {
  width: 282px;
  height: 159px;
  position: absolute;
  right: 37px;
  top: 50%;
  transform: translateY(-50%);
}
.box .box3 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  height: 412px;
  position: relative;
}
.box3 ul {
  margin-right: 52px;
}
.gray span {
  font-family: Lato;
  font-style: normal;
  color: #999;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
}
.box .te {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
  margin-top: -1px;
  margin-right: 52px;
}
.box4 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  padding-right: 65px;
  position: relative;
}
.box4 img {
  position: absolute;
  width: 172px;
  height: 172px;
  right: 82px;
  top: 40px;
}
.box4 h3 {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #000000;
  margin-top: 30px;
  margin-bottom: 20px;
}
.box5 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  position: relative;
}
.circle {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 2px solid #181818;
  box-sizing: border-box;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  color: #000000 !important;
  margin-right: 17px;
}
.box4 .box4ul li {
  /* list-style: none; */
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
}
.box4 ul {
  margin-left: -18px;
  margin-bottom: 30px;
}
.box4 .box4ul2 li {
  list-style: disc;
  margin-left: 40px;
}
.box5 p {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
}
.box4p {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #000000;
  margin-bottom: 30px;
}
a {
  color: #0000ee;
}

</style>